import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { ModuleGroup } from '../../module-group/models/module-group';
import { FetchModuleGroup, FetchModuleGroupFailure, FetchModuleGroupSuccess } from '../actions';
import { ModuleGroupState } from '../models/module-group.state';

@Injectable()
export class ModuleGroupService {
    @Select(ModuleGroupState.getEntities)
    moduleGroup$: Observable<ModuleGroup[]>;

    constructor(private _store: Store, private _actionHelper: NgxsActionHelper) {}

    getModuleGroup(): ModuleGroup {
        return this._store.selectSnapshot(ModuleGroupState.getEntity);
    }

    getModuleGroupById(id: string): ModuleGroup {
        return ModuleGroupState.getEntity(this._store.selectSnapshot(ModuleGroupState), id);
    }

    async fetchModuleGroup(groupId: string): Promise<boolean> {
        this._store.dispatch(new FetchModuleGroup(groupId));

        return await this._actionHelper.race(FetchModuleGroupSuccess, FetchModuleGroupFailure).toPromise();
    }
}
